import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { push } from 'react-router-redux';
import RequestGrid from '../../components/grids/RequestGrid';
import AssigneeBulkAssignDialog from '../../components/AssigneeBulkAssignDialog';
import { isInternal, isOfficialAdmin, publicUrlHelpLogged } from '../../CroUtils';
import { fetchM } from '../../../../utils/fetch';
import { bulkAssign, getAssignees } from '../../CroActions';
import ShowOverviewHistoryButton from '../../components/audit/ShowOverviewHistoryButton';

class Requests extends Component {
  state = {
    selectedIds: [],
    dialogOpen: false,
    pendingAssigneeId: '',
    items: [],
    assignees: null,
  };

  async componentWillMount() {
    this.props.breadcrumbs([{ label: 'Žádosti o nahlédnutí na neveřejné oznámení' }]);
    const assignees = await getAssignees(this.props.dispatch);
    this.setState({ assignees: assignees?.items || [] });
  }

  onEdit = ({ id }) => {
    this.props.push(`${publicUrlHelpLogged(this.props.auth)}/zadosti/form/${id}`);
  }

  onAdd = () => {
    this.props.push(`${publicUrlHelpLogged(this.props.auth)}/zadosti/form`);
  }

  onAssign = (id, assigneeId) => {
    fetchM(`${this.props.auth.startUrl}/api/zadosti/${id}/assign`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: assigneeId ? JSON.stringify({ id: assigneeId }) : null,
    }).then(() => this.reloadGrid());
  }

  onShowAssign = (selectedIds) => {
    this.setState({ selectedIds, dialogOpen: true, pendingAssigneeId: '' });
  }

  onCancel = () => {
    this.setState({ dialogOpen: false, pendingAssigneeId: '' });
  }

  onConfirm = async () => {
    const { selectedIds, pendingAssigneeId } = this.state;
    const { dispatch, auth } = this.props;

    await bulkAssign({
      url: `${auth.startUrl}/api/zadosti/prideleni`,
      itemIds: selectedIds,
      assigneeId: pendingAssigneeId || null,
    })(dispatch);

    this.setState({ dialogOpen: false, selectedIds: [], pendingAssigneeId: '' });
    this.reloadGrid();
  }

  reloadGrid = () => {
    this.setState({ items: [...this.state.items, 0] });
  }

  render() {
    const { auth } = this.props;
    const { dialogOpen, selectedIds, pendingAssigneeId, items, assignees } = this.state;
    const admin = isOfficialAdmin(auth);

    return (
        (assignees &&<div>
          <ShowOverviewHistoryButton auth={auth} segment="zadosti" />
          <RequestGrid
              gridName="requestsGrid_internal"
              onRowClick={this.onEdit}
              url={`${auth.startUrl}/api/zadosti`}
              items={items}
              adding={isInternal(auth)}
              onAdd={this.onAdd}
              auth={auth}
              assignees={assignees}
              onAssign={this.onAssign}
              allowCheck={admin}
              moreCheckboxFns={admin}
              fnText="Přidělit zpracovatele"
              onCheckboxFn={this.onShowAssign}
          />

          <AssigneeBulkAssignDialog
              open={dialogOpen}
              selectedCount={selectedIds.length}
              assignees={assignees}
              assigneeId={pendingAssigneeId}
              onAssigneeChange={(id) => this.setState({ pendingAssigneeId: id })}
              onConfirm={this.onConfirm}
              onCancel={this.onCancel}
          />
        </div>)
    );
  }
}

const mapStateToProps = (state) => ({ auth: state.sidebar.auth });

export default connect(
    mapStateToProps,
    (dispatch) => ({
      dispatch,
      breadcrumbs: (...args) => dispatch(breadcrumbs(...args)),
      push: (path) => dispatch(push(path)),
    }),
)(Requests);